import { subscribeToNewsletter } from '~/services/mailchimp';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('mailchimp', {
    subscribeToNewsletter
  });
});
